import { useEffect, useState } from 'react';
import { useInactiveBotActivator } from './use-inactive-bot-activator';

export const useShowInactiveBannerFlag = () => {
  const { activateChatbotWithCallback, isActiveChatbot, onClickActivate } =
    useInactiveBotActivator();
  const [botAlertVisible, setBotAlertVisible] = useState(!isActiveChatbot);

  useEffect(() => {
    setBotAlertVisible(!isActiveChatbot);
  }, [isActiveChatbot]);

  return {
    botAlertVisible,
    setBotAlertVisible,
    onClickActivate,
    activateChatbotWithCallback,
  };
};
